/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';

interface HeaderNavProps {
  user: string | null;
}

const HeaderNav = ({ user }: HeaderNavProps) => {
  const signedIn = user !== null && user !== '0';

  return (
    <nav id="tf-menu" className="navbar navbar-expand-lg navbar-dark fixed-top">
      <div className="container">
        <a className="navbar-brand" href="/">ΠΟωaττ</a>
        <button
          className="navbar-toggler collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#bs-example-navbar-collapse-1"
          aria-controls="bs-example-navbar-collapse-1"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div id="bs-example-navbar-collapse-1" className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"><a className="nav-link page-scroll" href="/">Home</a></li>
            <li className="nav-item"><a className="nav-link page-scroll" href="/#tf-works">Products</a></li>
            <li className="nav-item"><a className="nav-link page-scroll" href="/#tf-industries">Industries</a></li>
            <li className="nav-item"><a className="nav-link page-scroll" href="/#tf-services">Services</a></li>
            <li className="nav-item"><a className="nav-link page-scroll" href="/#tf-about">About</a></li>
            {!signedIn && (
              <li className="nav-item"><a className="nav-link page-scroll" href="/login">Sign-in</a></li>
            )}
            {signedIn && (
              <>
                <li className="nav-item"><a className="nav-link page-scroll" href="/usage">Usage</a></li>
                <li className="nav-item"><a className="nav-link page-scroll" href="/Logout">Logout</a></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HeaderNav;
